'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.combineReducers = combineReducers;

var _loop = require('./loop');

var _effects = require('./effects');

var _utils = require('./utils');

function optimizeBatch(effects) {
  switch (effects.length) {
    case 0:
      return (0, _effects.none)();
    case 1:
      return effects[0];
    default:
      return (0, _effects.batch)(effects);
  }
}

function combineReducers(reducerMap) {
  return function finalReducer() {
    var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
    var action = arguments[1];

    var effects = [];
    var hasChanged = false;

    var model = (0, _utils.mapValues)(reducerMap, function (reducer, key) {
      var previousStateForKey = state[key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if ((0, _loop.isLoop)(nextStateForKey)) {
        effects.push((0, _loop.getEffect)(nextStateForKey));
        var _model = (0, _loop.getModel)(nextStateForKey);
        hasChanged = hasChanged || _model !== previousStateForKey;
        return _model;
      } else {
        hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        return nextStateForKey;
      }
    });

    return (0, _loop.loop)(hasChanged ? model : state, optimizeBatch(effects));
  };
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-loop/lib/combineReducers.js
 ** module id = 236
 ** module chunks = 0
 **/